// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__UlAdu","readOnly":"styles_readOnly__WhVie"};